<template>
	<div class="shopOder">
		<back-to></back-to>
		<div class="address" @click="orderSaleshow" v-if="type == 1">
			<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-05.png" alt="" class="addres-left">
			<label for="" class="addres-center">
				<p>{{getTicketName != '' ? getTicketName: '请设置您的收货地址'}}</p>
				<p class="hide">{{getTicketAress != '' ? getTicketAress:'点击设置'}}</p>
			</label>
			<img class="addres-right" src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-06.png">
		</div>
		<div class="content">
			<div class="content-img">
				<label for="" class="content-imgs">
					<img :src="images" alt="">
				</label>
				<label for="" class="content-img-text">
					<p>{{proInfo.name}}</p>
					<p>{{proInfo.startDate}}</p>
					<p>兑换积分:{{proInfo.score}}</p>
				</label>
			</div>
			<div class="content-l" v-if="type == 1">
				<p>配送方式</p>
				<p>快递免邮</p>
			</div>
			<div class="content-l">
				<p>数量</p>
				<p>1</p>
			</div>
			<div class="det-b">
				<div class="det-b-t">订单备注</div>
				<textarea class="det-b-n" placeholder="填写您的备注" bindinput="fnRemark"></textarea>
			</div>
		</div>
		<div class="amount">
			<div class="amount-t">兑换合计:</div>
			<div class="amount-s">{{proInfo.score}}积分</div>
		</div>
		<div class="btn" @click="exchange">立即兑换</div>
		<!-- 出行人信息 -->
		<van-popup class="orderPopupt" v-model="travelerShow" round position="bottom" @click-overlay="travelerCancel">
			<div class="orderPopup-sure">
				<span @click="travelerCancel">取消</span>
				<span @click="travelerTrue">确认</span>
			</div>
			<div class="orderPopup-add">
				<span @click="$router.push({ path: '/shopTraveler',query:{type:0}})">+新增</span>
			</div>
			<div class="orderPopup-list">
				<ul>
					<li v-for="(item,index) in travelerList" :key="index" @click="selectTravelers(index)">
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_07.png"
							@click.stop="$router.push({ path: '/shopTraveler',query:{type:1,id:item.id}})" alt="">
						<!-- <p>{{item.templatTag[0].tagValue}}</p>
						<p>{{item.templatTag[1].tagValue}}</p> -->
						<!-- <p v-for="(map,sort) in item.templatTag" :key="sort" v-if="map.isMain">{{map.tagValue}}</p> -->
						<p>{{item.realName}}</p>
						<p class="hide">{{item.provStr}}{{item.cityStr}}{{item.countryStr}}{{item.address}}</p>
						<span class="orderPopup-lists">
							<img v-if="item.isSelect"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_08.png"
								alt="">
							<font v-if="!item.isSelect" class="select-false"></font>
						</span>
					</li>
				</ul>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		_throttle
	} from '@/config/util'
	import {
		Toast
	} from 'vant';
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'shop',
		components: {
			BackTo
		},
		data() {
			return {
				proInfo: '',
				travelerList: '',
				travelerShow: false,
				isdess: false,
				getTicketName: '',
				getTicketAress: '',
				isID: 0,
				type: 0,
				remark: '',
				proId: 0,
				travelerListCurent: '',
				images: ''
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getTravelerList()
			this.getContent()
			this.proId = this.$route.query.id
			this.type = this.$route.query.type
		},
		methods: {
			travelerCancel() {
				this.travelerShow = false
			},
			travelerTrue() {
				this.travelerShow = false
			},
			orderSaleshow() {
				this.travelerShow = true
			},
			selectTravelers(index) {
				var travelerList = this.travelerList
				var selectLength = travelerList.filter(item => item.isSelect == true)
				if (selectLength < 1) {
					travelerList[index].isSelect = !travelerList[index].isSelect
				} else {
					var sort = travelerList.findIndex(item => item.isSelect == true)
					travelerList[sort].isSelect = !travelerList[sort].isSelect
					travelerList[index].isSelect = !travelerList[index]
						.isSelect
				}
				var getTicketAress = travelerList[index].provStr + travelerList[index].cityStr + travelerList[index]
					.countryStr + travelerList[index].address

				this.travelerList = travelerList
				this.getTicketAress = getTicketAress
				this.getTicketName = travelerList[index].realName
				this.travelerListCurent = travelerList[index]
				console.log(travelerList)
			},
			getTravelerList() {
				let param = {
					UserId: this.userInfo.userId,
					Sorting: '0',
					SkipCount: 0,
					MaxResultCount: 100
				}

				this.$get(
					this.$connectHttpSweet + '/ShippingAddress/GetPaged', param
				).then(res => {
					for (let i = 0; i < res.result.items.length; i++) {
						res.result.items[i].isSelect = false
					}
					res.result.items[0].isSelect = true
					var getTicketAress = res.result.items[0].provStr + res.result.items[0].cityStr + res.result
						.items[0].countryStr + res.result.items[0].address

					this.travelerList = res.result.items
					this.getTicketAress = getTicketAress
					this.getTicketName = res.result.items[0].realName
					this.travelerListCurent = res.result.items[0]

				})
			},
			getContent(id) {
				var jsonData = {
					id: this.$route.query.id
				}
				this.$get(
					this.$activity + '/Score/ScoreProductGetById', jsonData
				).then(res => {
					res.startDate = res.startDate.substring(0, 19).replace('T', ' ')
					this.proInfo = res
					this.images = res.images[0]

				})
			},
			exchange: _throttle(function(_type, index, item) {
				if (this.type != 3 && (this.travelerListCurent == '' || this.travelerListCurent == undefined)) {
					Toast('请您先补全收货地址')
					return;
				}
				let param = {
					"useScore": this.proInfo.score,
					"count": 1,
					"name": (this.travelerListCurent == '' || this.travelerListCurent == undefined) ?
						'' : this.travelerListCurent.realName,
					"phone": (this.travelerListCurent == '' || this.travelerListCurent ==
						undefined) ? '' : this.travelerListCurent.userPhone,
					"province": (this.travelerListCurent == '' || this.travelerListCurent ==
						undefined) ? '' : this.travelerListCurent.provStr,
					"city": (this.travelerListCurent == '' || this.travelerListCurent == undefined) ?
						'' : this.travelerListCurent.cityStr,
					"area": (this.travelerListCurent == '' || this.travelerListCurent == undefined) ?
						'' : this.travelerListCurent.countryStr,
					"address": (this.travelerListCurent == '' || this.travelerListCurent ==
						undefined) ? '' : this.travelerListCurent.address,
					"webUserId": this.userInfo.userId,
					"ptId": this.$organizationId,
					"scoreProductId": Number(this.proId)
				}
				this.$get(
					this.$activity + '/Score/ScoreExchangeAdd', param
				).then(res => {
					if (res.isSuccess) {
						Toast('兑换成功')
						setTimeout(() => {
							if (this.type == 3) {
								this.$router.back()
							} else {
								this.$router.push({
									path: '/exchange'
								})
							}
						}, 2000);
					} else {
						Toast('兑换失败' + res.error)
					}

				})
			}, 3000),
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.shopOder {
		width: 100%;
		padding: 20px 28px;
		box-sizing: border-box;
	}

	.address {
		width: 100%;
		height: 160px;
		display: flex;
		align-items: center;
		background: #fff;
		border-radius: 18px;
		padding: 0px 30px;
		box-sizing: border-box;
	}

	.addres-left {
		height: 60px;
		width: 60px;
	}

	.addres-right {
		height: 22px;
		width: 12px;
		margin-left: auto;
	}

	.addres-center {
		display: flex;
		flex-direction: column;
		padding-left: 40px;
		box-sizing: border-box;
		font-size: 26px;
		color: #333;
	}

	.addres-center p:first-child {
		font-size: 30px;
		color: #333;
		margin-bottom: 25px;
	}


	.content {
		margin-top: 20px;
		width: 100%;
		border-radius: 18px;
		background-color: #fff;
		padding: 30px;
		box-sizing: border-box;
	}

	.content-img {
		display: flex;
		padding-bottom: 20px;
	}

	.content-imgs,
	.content-imgs img {
		height: 160px;
		width: 160px;
		border-radius: 18px;
	}

	.content-img-text {
		display: flex;
		flex-direction: column;
		height: 160px;
		justify-content: space-between;
		padding-left: 40px;
		font-size: 26px;
		color: #666;
	}

	.content-img-text p:last-child {
		font-size: 26px;
		color: #ff8a00;
	}

	.content-l {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 40px;
		color: #333;
		font-size: 26px;
	}

	.content-l p:last-child {
		color: #999;
	}

	.det-b {
		width: 100%;
		margin-top: 40px;
		color: #333;
		font-size: 26px;
		display: flex;
	}

	.det-b-n {
		margin-left: 40px;
		flex: 1;
		height: 120px;
		border: none;
		padding: 1px;
	}

	.amount {
		width: 100%;
		background: #fff;
		padding: 30px 20px;
		display: flex;
		justify-content: space-between;
		border-radius: 18px;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.amount-t {
		font-size: 26px;
		color: #333;
	}

	.amount-s {
		font-size: 26px;
		color: #ff8a00;
	}

	.btn {
		height: 88px;
		width: 100%;
		color: #fff;
		text-align: center;
		line-height: 88px;
		font-size: 36px;
		z-index: 99;
		position: fixed;
		bottom: 0;
		left: 0;
		background: #ff8a00;
		margin-bottom: constant(safe-area-inset-bottom);
		margin-bottom: env(safe-area-inset-bottom);
	}

	.hide {
		display: -webkit-box;
		overflow: hidden;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		width: 420rpx;
	}

	.orderPopupt {
		width: 100%;
		padding: 30px 0;
		height: 600px;
	}

	.orderPopup-sure {
		display: flex;
		justify-content: space-between;
		width: 100%;
		font-size: 30px;
		border-bottom: 1px solid #f2f2f2;
		padding: 0 70px 30px 70px;
		box-sizing: border-box;
	}

	.orderPopup-sure span:first-child {
		color: #ccc;
	}

	.orderPopup-sure span:last-child {
		color: #ff6d00;
	}

	.orderPopup-add {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.orderPopup-add span {
		background: #f5f5f5;
		height: 80px;
		font-size: 40px;
		color: #ff6d00;
		text-align: center;
		line-height: 80px;
		border-radius: 5px;
		width: 100%;
	}

	.orderPopup-list {
		width: 100%;

	}

	.orderPopup-list li {
		padding: 10px 50px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		border-bottom: #f5f5f5 solid 1px;
		font-size: 30px;
		color: #333;
		height: 100px;

	}

	.orderPopup-list li p {
		margin-left: 30px;
	}

	.orderPopup-list img {
		width: 28px;
		height: 28px;
	}

	.select-false {
		display: block;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.orderPopup-lists {
		margin-left: auto;
	}
</style>
